import getGallery from '../../components/getGallery'
import regular from 'shido.regular.js/src/regular.js'

const init = () => {
  new getGallery().init()
  new regular().init()
}

export default init
